module.exports = __webpack_public_path__ + "img/icon_product-select.939b84ad.png";